import React from 'react'
import 'react-toastify/dist/ReactToastify.css';

import AuthRoute from './components/AuthRoute';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import SignupPage from './pages/SignupPage';
import SigninPage from './pages/SigninPage';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './app.scss';
import HistoryPage from './pages/HistoryPage';
import ReportPage from './pages/ReportPage';
import PreservePage from './pages/PreservePage';
import BasePage from './pages/BasePage';

function App() {
    const theme = createTheme({
        palette: { mode: 'dark' },
    });

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <ToastContainer
                position="bottom-left"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnHover
            />
            <BrowserRouter>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <HomePage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/history"
                        element={
                            <ProtectedRoute>
                                <HistoryPage/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/report"
                        element={
                            <ProtectedRoute>
                                <ReportPage/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/preserve"
                        element={
                            <ProtectedRoute>
                                <PreservePage/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/basexp"
                        element={
                            <BasePage/>
                        }
                    />
                    <Route
                        path="/signin"
                        element={
                            <AuthRoute>
                                <SigninPage />
                            </AuthRoute>
                        }
                    />
                    <Route
                        path="/signup"
                        element={
                            <AuthRoute>
                                <SignupPage />
                            </AuthRoute>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
